import nameValidator from './nameValidator';

export default nameValidator;
